import { useEffect, useState } from "react";
import { useLang } from "../../contexts/LangContext";
import { useLogSession } from "../../contexts/LogSessionContext";
import { useNavigate } from "react-router-dom";
import { v4 as uuidv4 } from "uuid";
import { getLocalDateString } from "../../utils/misc";
import { storageService } from "../../services/storage.service";

export default function WhichMeal() {
  const { t } = useLang();
  const { currentDayRecord, setcurrentMealRecord, setNewFishItem } =
    useLogSession();
  const navigate = useNavigate();

  useEffect(() => {
    setcurrentMealRecord(null); // Reset any previous meal record
    setNewFishItem(null);
  }, []);

  const [hasLunch, setHasLunch] = useState(true);
  const [hasSnack, setHasSnack] = useState(true);
  const [hasDinner, setHasDinner] = useState(true);

  useEffect(() => {
    const checkMealAvailability = async () => {
      const settings = await storageService.getSettings();
      if (!settings.restrictMealsByTime) {
        // Setting disabled: show all meals always
        setHasLunch(true);
        setHasSnack(true);
        setHasDinner(true);
        return;
      }

      const localTime = new Date();
      const today = getLocalDateString(localTime);
      if (currentDayRecord?.date === today) {
        const currentHour = localTime.getHours();
        setHasLunch(currentHour >= 12); // Lunch is available if it's past 12 PM
        setHasSnack(currentHour >= 16); // Snack is available if it's past 4 PM
        setHasDinner(currentHour >= 19); // Dinner is available if it's past 7 PM
      }
    };

    checkMealAvailability();
  }, [currentDayRecord]);

  const handleSelect = (
    meal_type: "breakfast" | "lunch" | "dinner" | "snack"
  ) => {
    const existingMeal =
      currentDayRecord?.meals.find((meal) => meal.meal_type === meal_type) ||
      null;

    setcurrentMealRecord(
      existingMeal || {
        id: uuidv4(),
        meal_type,
        fish_items: [],
        updated_at: new Date().toISOString(),
      }
    );
    navigate("../which-fish");
  };

  return (
    <div className="w-full grow flex flex-col items-center justify-start gap-10 text-center px-scr pt-12">
      <h1 className="text-3xl font-bold text-rose-700">
        {t("whichMeal_Heading")}
      </h1>

      <div className="flex flex-col gap-4 w-full max-w-xs pb-8">
        <button
          type="button"
          onClick={() => handleSelect("breakfast")}
          className="w-full button-base button-bg-grad-green"
        >
          {t("mealType_breakfast")}
        </button>
        
        <button
          type="button"
          onClick={() => handleSelect("lunch")}
          className={`w-full button-base ${hasLunch ? "button-bg-grad-green" : "button-bg-grad-lightgray "}`}
          disabled={!hasLunch}
        >
          {t("mealType_lunch")}
        </button>       
     
        <button
          type="button"
          onClick={() => handleSelect("snack")}
          className="w-full button-base button-bg-grad-green"
        >
          {t("mealType_snack")}
        </button>     
       
        <button
          type="button"
          onClick={() => handleSelect("dinner")}
          className={`w-full button-base ${hasDinner ? "button-bg-grad-green" : "button-bg-grad-lightgray "}`}
          disabled={!hasDinner}
        >
          {t("mealType_dinner")}
        </button>
     
      </div>
    </div>
  );
}
